export default __webpack_public_path__ + "static/media/PPI-pools-004.8b3f2069.jpg";